module.exports = __webpack_public_path__ + "img/chinesecompany159.db0817b5.png";